import { atom } from 'recoil';
import { carReplacementSelector } from '../selectors/carReplacementSelector';
import type { ReplacementCarDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';

export const carReplacementsAtom = atom<ReplacementCarDTO[] | undefined>({
    key: 'carReplacementsAtom',
    default: carReplacementSelector
});
